/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Settings16({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="16"
      role="img"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10.45a2.45 2.45 0 1 0 0-4.9 2.45 2.45 0 0 0 0 4.9Z"
        fill={CssVars.textColor}
      />
      <path
        clipRule="evenodd"
        d="M15 6.6v2.8l-1.68.28c-.07.28-.21.63-.35.91l.98 1.4-1.96 1.96-1.4-.98c-.28.14-.56.28-.91.35L9.4 15H6.6l-.28-1.68a4.86 4.86 0 0 1-.91-.35l-1.4.98-1.96-1.96.98-1.4c-.14-.28-.28-.56-.35-.91L1 9.4V6.6l1.68-.28c.07-.28.21-.63.35-.91l-.98-1.4 1.96-1.96 1.4.98c.28-.14.63-.28.91-.35L6.6 1h2.8l.28 1.68c.28.07.63.21.91.35l1.4-.98 1.96 1.96-.98 1.4c.14.28.28.56.35.91L15 6.6Zm-7 5.35a3.95 3.95 0 1 0 0-7.9 3.95 3.95 0 0 0 0 7.9Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
